import { Injectable } from '@angular/core';
import { ApiSelector, Filter, Pagination } from '@iot-platform/models/common';
import { Product } from '@iot-platform/models/oyan';
import * as fromMain from '../reducers';
import * as fromSiteProducts from '../reducers/site-products.reducer';

@Injectable({
  providedIn: 'root'
})
export class SiteProductsSelectors extends ApiSelector<fromMain.State, Product, Pagination, Filter> {
  constructor() {
    super(fromMain.featureKey, fromSiteProducts.featureKey, fromSiteProducts.adapter);
  }
}
